import { AlertController, AlertOptions, LoadingController } from '@ionic/angular/standalone';
import { Injectable, inject } from '@angular/core';

/**
 * This service holds the functionality for alerts and loading dialogs
 * until they when they have a meaningful web-counterpart.
 * Then they might be added back in ./message.service.ts.
 */

@Injectable({
  providedIn: 'root',
})
export class IonicControllerService {
  private readonly alertController = inject(AlertController);
  private readonly loadingController = inject(LoadingController);

  public async presentLoader(message = ''): Promise<void> {
    const loading = await this.loadingController.create({
      message,
    });
    await loading.present();
  }

  public async dismissLoader(): Promise<void> {
    const loading = await this.loadingController.getTop();
    if (loading) {
      await loading.dismiss();
    }
  }

  public async showAlert(alertOptions: AlertOptions): Promise<void> {
    const alert = await this.alertController.create(alertOptions);
    await alert.present();
  }
}
